import { ApiResponse, ErrorResponse } from "@schemas/api";
import { FormHelper } from "./form-helper";
export class StringHelper {
  public isValidString = StringHelper.isValidString;

  public static toUrlString(obj: Record<string, any>): string {
    const params: string[] = [];

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];

        if (Array.isArray(value)) {
          value.forEach((item: any) => {
            params.push(`${key}=${encodeURIComponent(item)}`);
          });
        } else if (value !== null && value !== undefined) {
          params.push(`${key}=${encodeURIComponent(value)}`);
        }
      }
    }

    return params.join("&");
  }
  public static currencyFormat(
    num: number,
    isMinor = true,
    hasDecimals = true
  ) {
    if (!num && num !== 0) {
      return 0;
    }
    if (isMinor) {
      num = num / 100;
    }
    return num
      ?.toFixed(hasDecimals ? 2 : 0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  public static formatNumber(n: string): string {
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  public static hasErrors(error: ErrorResponse) {
    return Boolean(error?.hasOwnProperty("message"));
  }
  public static isJSON(data: any) {
    if (typeof data !== "string") {
      return false;
    }

    try {
      JSON.parse(data);
      return true;
    } catch (error) {
      return false;
    }
  }
  public static getFirstName(data: any) {
    if (typeof data !== "string") {
      return "";
    }

    return data.split(" ")[0];
  }

  public static getErrorMessage(
    error: ErrorResponse,
    defaultMessage: string = "Something went wrong!!"
    // "Unable to complete request."
  ): string {
    if (error?.status === 401) {
      return "Session Expired, Please Log back in to continue";
    }
    if (this.hasErrors(error)) {
      return error.message || "An error occured";
    } else if (
      error?.hasOwnProperty("errors") &&
      error["data"] &&
      error["data"]["error"].message
    ) {
      return error["data"]["error"].message;
    } else {
      return defaultMessage;
    }
  }

  private static isErrorUserFriendly(err: string) {
    const exceptions = ErrorExceptions;
    const hasException = exceptions.filter(
      (ex) => err.toLowerCase().indexOf(ex) !== -1
    );

    if (hasException && hasException.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  public static isValidString(val: any): boolean {
    return val != null && val !== undefined && val.toString().length > 0;
  }

  public static isValidStrings(...values: string[]): boolean {
    let isValid = true;
    if (values.length > 0) {
      for (let i = 0; i < values.length; i++) {
        if (!StringHelper.isValidString(values[i])) {
          isValid = false;
          break;
        }
      }
    } else {
      isValid = false;
    }

    return isValid;
  }

  public static randomStrings() {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < 8; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  /**
   * This enhances the supplied object with methods in this class. This enables you to use
   * the methods in your component's html without referencing the StringHelper.
   * @param obj Object to be decorated, expecting a component.
   */
  public static decorate(obj: any) {
    const methodKeys = Object.keys(this);
    methodKeys.forEach((method) => {
      if (method !== "decorate" && !obj.hasOwnProperty(method)) {
        obj[method] = this[method as keyof Object];
      }
    });
  }

  public static formatConcatenatedString(concatString: string): string {
    let formattedString = "";
    if (concatString) {
      concatString.split("_").forEach((word) => {
        const lowerCaseString: string = word.toLowerCase();
        formattedString +=
          lowerCaseString.charAt(0).toUpperCase() +
          lowerCaseString.slice(1) +
          " ";
      });
    }
    return formattedString;
  }

  public static toTitleCase(str: string): string {
    if (str) {
      return str
        .toLowerCase()
        .split(" ")
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    }
    return str;
  }

  public static decodeJWT(token: string) {
    const base64Url = token.split(".")[1];
    if (base64Url) {
      const base64 = base64Url.replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(base64));
    } else {
      return undefined;
    }
  }

  public static queryStringToJSON(qs: string) {
    qs = qs || window.location.search.slice(1);

    var pairs = qs.split("&");
    var result: any = {};
    pairs.forEach(function (p) {
      var pair = p.split("=");
      var key = pair[0];
      var value = decodeURIComponent(pair[1] || "");

      if (result[key]) {
        if (Object.prototype.toString.call(result[key]) === "[object Array]") {
          result[key].push(value);
        } else {
          result[key] = [result[key], value];
        }
      } else {
        result[key] = value;
      }
    });

    return JSON.parse(JSON.stringify(result));
  }

  public static getDisplayStatus(status: string) {
    switch (status?.toLowerCase()) {
      case "pending":
        return "warning";
      case "credit":
        return "success";
      case "debit":
        return "danger";
      case "failed":
        return "danger";
      case "success":
        return "success";
      case "successful":
        return "success";
      case "deposited":
        return "success";
      case "approved":
        return "success";
      case "disapproved":
        return "danger";
      default:
        return "warning";
      case "active":
        return "success";
      case "inactive":
        return "danger";
    }
  }
  public static setEditStatus(status: string) {
    switch (status) {
      case "PENDING":
      case "DECLINED":
        return false;

      case "IN_REVIEW":
      case "FOR_APPROVAL":
      case "APPROVED":
        return true;

      default:
        return false;
    }
  }

  public static fetchTypeByValue(sortData: any, value: string) {
    const data = sortData.filter((e: any) => {
      return e.name === value;
    });
    return data[0];
  }

  public static removeUnderScore(value: string) {
    return value.replace(/_/gi, " ");
  }

  /**
   * It removes empty properties from an object
   * @param obj - The object to remove empty properties from.
   * @param {string[]} keys - The keys to check for empty values. If not provided, all keys will be
   * checked.
   * @param [removeNestedProperty=true] - If true, it will remove the nested properties as well.
   */

  public static blobToBase64(blob: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  public static getFileFormatByFileName(name: string) {
    const filename = name;

    // Get the portion of the string after the last dot
    const format = filename.substring(filename.lastIndexOf(".") + 1);

    return format;
  }
  public static removeEmptyKeys(obj: any) {
    const result: any = {};

    for (const key in obj) {
      if (
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== "" &&
        obj[key] !== 0
      ) {
        if (typeof obj[key] === "object") {
          const nestedObj = StringHelper.removeEmptyKeys(obj[key]);
          if (Object.keys(nestedObj).length > 0) {
            result[key] = nestedObj;
          }
        } else {
          result[key] = obj[key];
        }
      }
    }

    return result;
  }
}

export const ErrorExceptions = [
  "exception",
  "null",
  "springboot",
  "exceptions",
  "resultset",
  "sql",
  "hibernate",
];
